/**
 * Configuración de variables de entorno
 * Centraliza el acceso a las variables de entorno de la aplicación
 */

interface AppConfig {
  apiUrl: string;
  environment: 'development' | 'production' | 'test';
  enableLogging: boolean;
  apiTimeout: number;
}

/**
 * Obtiene la configuración de la aplicación desde variables de entorno
 */
const getConfig = (): AppConfig => {
  return {
    apiUrl: process.env.REACT_APP_API_URL || 'http://localhost:8787',
    environment: (process.env.REACT_APP_ENV as AppConfig['environment']) || 'development',
    enableLogging: process.env.REACT_APP_ENABLE_LOGGING === 'true',
    apiTimeout: Number(process.env.REACT_APP_API_TIMEOUT) || 10000,
  };
};

/**
 * Configuración de la aplicación
 * @example
 * import { config } from '@/config/env';
 * console.log(config.apiUrl);
 */
export const config = getConfig();

/**
 * Helper para verificar el entorno actual
 */
export const isDevelopment = config.environment === 'development';
export const isProduction = config.environment === 'production';
export const isTest = config.environment === 'test';

/**
 * Logger condicional basado en el entorno
 */
export const log = {
  info: (...args: any[]) => {
    if (config.enableLogging) {
      console.log('[INFO]', ...args);
    }
  },
  warn: (...args: any[]) => {
    if (config.enableLogging) {
      console.warn('[WARN]', ...args);
    }
  },
  error: (...args: any[]) => {
    if (config.enableLogging) {
      console.error('[ERROR]', ...args);
    }
  },
  debug: (...args: any[]) => {
    if (config.enableLogging && isDevelopment) {
      console.debug('[DEBUG]', ...args);
    }
  },
};

